import React from "react";

import * as Styled from "./styles";

interface Props {
  active: boolean;
  title: string;
  onClick: () => void;
}

const ConcretingButton: React.FC<Props> = ({ active, onClick, title }) => (
  <Styled.Container active={active} onClick={onClick} disabled={active}>
    {title}
  </Styled.Container>
);

export default ConcretingButton;
